<template>
  <div>
    <p style="margin-bottom: 0">Champs disponibles</p>
    <draggable
      class="list-group"
      :list="fields"
      :group="{ name: 'people', pull: 'clone', put: false }"
    >
      <div
        class="list-group-item"
        v-for="element in fields"
        :key="element.name"
      >
        {{ element.name }}
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  components: { draggable },
  props: ["fields"],
  data() {
    return {};
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/component/Import/Formater/DraggableFieldsList.vue